// URL für Accounting-Downloads - nutzt den lokalen Proxy
const URLForDownloadCloseAccountingSCV = '/accounting';
export default URLForDownloadCloseAccountingSCV;
